// extracted by mini-css-extract-plugin
export default {"table":"GK","tbody":"HK","tr":"IK","td":"JK","right":"KK","recurringdis":"LK"};
    if(module.hot) {
      // 1713969935127
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  